import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "button"];

  toggle() {
    this.panelTarget.classList.toggle("-translate-x-full");
    this.buttonTarget.classList.toggle("text-sky-500");
  }
}
